var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Screen',{attrs:{"progress":_vm.progress}},[_c('Slide',[_c('Record',{attrs:{"data":{
        trialNr: _vm.index + 1,
        item_id: _vm.trial.item_id,
        trial_type: _vm.trial_type,
        inference_type: _vm.trial.inference_type,
        assumption: _vm.trial.assumption_name,
        correct_answer: _vm.correct_answer
      }}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.createContext(_vm.trial, _vm.trial_type))}}),_c('br'),_c('br'),_c('ForcedChoiceInput',{attrs:{"response":_vm.$magpie.measurements.violation,"options":['Yes', 'No']},on:{"update:response":[function($event){return _vm.$set(_vm.$magpie.measurements, "violation", $event)},function($event){return _vm.$magpie.saveAndNextScreen();}]}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }